import type { FC } from 'react'
import { CircularProgress } from '@material-ui/core'
import ravenImage from '../assets/images/raven.png'

const LoadingScreen: FC = () => {
  return (
    <div
      style={{
        alignItems: 'center',
        backgroundColor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        width: '100%'
      }}
    >
      <img alt="Corvum" src={ravenImage} style={{ height: 75 }} />
      <CircularProgress
        size={120}
        sx={{
          position: 'absolute'
        }}
      />
    </div>
  )
}

export default LoadingScreen
